import { render } from "./feedback.vue?vue&type=template&id=e2879fca&scoped=true"
import script from "./feedback.vue?vue&type=script&lang=js"
export * from "./feedback.vue?vue&type=script&lang=js"

import "./feedback.vue?vue&type=style&index=0&id=e2879fca&scoped=true&lang=css"

import exportComponent from "/Users/zonegoh/Documents/GitHub/levelup/level-up/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2879fca"]])

export default __exports__